import React from 'react'
import {Lang} from 'yougile-lang'

export const DealTimeLinePlaceholder = () => {
  return (
    <div className="text-14 text-secondary px-16 py-8">
      {Lang.msg.crm.rightPanel.dealHistory.noMsg}
    </div>
  )
}
